module.exports = __webpack_public_path__ + "sa.37465ef3b444c9d6a0ac.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sa.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sa.svg
// module chunks = styles